module.exports = __webpack_public_path__ + "img/nc.89fc0beb.svg";